<template>
  <div class="section-header">
    <div>
      <span>
        {{ number }}
      </span>
    </div>
    {{ text }}
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'SectionHeader',

  props: {
    number: {
      type: Number,
      default: 0,
    },
    text: {
      type: String,
      default: '',
    },
  },
});
</script>

<style scoped lang="scss">
.section-header {
  display: flex;
  align-items: center;

  font-weight: 500;
  font-size: var(--tSize-mdlg);
}
.section-header div {
  display: inline-block;
  width: 33px;
  height: 33px;
  background-color: var(--main-red);
  color: #fff;
  position: relative;
  border-radius: 50%;
  margin-right: 10px;
  flex-shrink: 0;
}
.section-header span {
  position: absolute;
  font-size: var(--tSize-lg);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
